import { atom } from 'recoil';
import BeaconFilterItemRequest from '../models/BeaconFilterItemRequest';

const stateFilterImgMeasure = atom({
  key: 'filter.img.measure',
  default: null as BeaconFilterItemRequest | null,
});

export default stateFilterImgMeasure;
